import { CommonModule } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { OverlayModule } from 'primeng/overlay';

import { TranslateModule } from '@ngx-translate/core';
import { AppState } from '@state/app.state';
import { setIsSidebar } from '@state/system/system.actions';

import { FormsModule } from '@angular/forms';
import { UserDTO as UserInfo } from '@chicilon/angular-user-service';
import { environment } from '@environments/environment';
import { ChangePasswordDialogComponent } from '@modules/settings/account-setting/components/change-password-dialog/change-password-dialog.component';
import { CustomAvatarComponent } from '@shared/components/custom-avatar/custom-avatar.component';
import { FlagsComponent } from '@shared/components/flags/flags.component';
import { NotificationComponent } from '@shared/components/notification/notification.component';
import { logout } from '@state/auth/auth.actions';
import { selectUserInfo } from '@state/auth/auth.selectors';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    RouterModule,
    BadgeModule,
    TranslateModule,
    AvatarModule,
    CommonModule,
    OverlayModule,
    FormsModule,
    NotificationComponent,
    CustomAvatarComponent,
    ChangePasswordDialogComponent
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild('flags') flagComponent!: FlagsComponent;

  readonly unsubscribe$ = new Subject();
  readonly translatePrefix = 'USER-MANAGEMENT.';
  readonly env = environment;

  isQa = false;

  SMALL_SCREEN = 1280;
  isSmallScreen = false;
  visible = false;
  isChangePassword = false;
  user$!: Observable<UserInfo | undefined>;

  constructor(private store: Store<AppState>) {}

  @HostListener('window:resize', ['$event'])
  checkSmallScreen() {
    this.isSmallScreen = window.innerWidth <= this.SMALL_SCREEN;
  }

  @HostListener('window:scroll', ['$event'])
  scroll() {
    this.visible = false;
  }

  ngOnInit(): void {
    this.checkSmallScreen();

    this.user$ = this.store.select(selectUserInfo);

    this.isQa = this.env.ENV === 'QA';
  }

  setSidebar() {
    this.store.dispatch(setIsSidebar({ isSidebar: true }));
  }

  onSignOut() {
    this.store.dispatch(logout());
  }

  onChangePassword() {
    this.visible = false;
    this.isChangePassword = true;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next('Complete');
    this.unsubscribe$.complete();
  }
}
